module.exports = __webpack_public_path__ + "img/GH-kyujin-top-osusume003.1e8f41b3.webp";